import logo from './logo.svg';
import './App.css';
import { Routes, Route, Switch } from 'react-router'
import Home from './componentes/home/Home';
import Layout from './componentes/layout/Layout';
import { useState } from 'react';
import Rankings from './componentes/rankings/Rankings';
import Informacion from './componentes/informacion/Informacion';
import Foro from './componentes/Foro/Foro';
import Tema from './componentes/Foro/Tema';
import Post from './componentes/Foro/Post';
import Descargas from './componentes/descargas/Descargas';

function App() {
  const [expanded, setExpanded] = useState(true);
  const [width, setWidth] = useState(window.innerWidth);
  const isMobile = width <= 768;

  return (
    <Routes>


      <Route exact path='/' element={<Home tyExpanded={expanded} setExpanded={setExpanded} isMobile={isMobile}/>} />
      <Route exact path='/rankings' element={<Rankings tyExpanded={expanded} setExpanded={setExpanded}  isMobile={isMobile}/>} />
      <Route exact path='/informacion' element={<Informacion tyExpanded={expanded} setExpanded={setExpanded}isMobile={isMobile} />} />
      <Route exact path='/foro' element={<Foro tyExpanded={expanded} setExpanded={setExpanded} isMobile={isMobile}/>} />
      <Route exact path='/foro/:id' element={<Tema tyExpanded={expanded} setExpanded={setExpanded} />} />
      <Route exact path='/foro/:temaId/:postId' element={<Post tyExpanded={expanded} setExpanded={setExpanded} isMobile={isMobile}/>} />
      <Route exact path='/descargas' element={<Descargas tyExpanded={expanded} setExpanded={setExpanded} isMobile={isMobile}/>} />



    </Routes>
  );
}

export default App;
